import { useContext, useEffect, useState } from 'react';
import Button from 'react-bootstrap/Button';
import Container from 'react-bootstrap/Container';
import Form from 'react-bootstrap/Form';
import { Helmet } from 'react-helmet-async';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Store } from '../Store';
import useAxios from '../hooks/useAxios';
import { getError, loginHandler } from '../utils';

export default function CustomerSignIn() {
  const Axios = useAxios();
  const navigate = useNavigate();
  const { search } = useLocation();
  const redirectInUrl = new URLSearchParams(search).get('redirect');
  const code = new URLSearchParams(search).get('code');
  const redirect = redirectInUrl ? redirectInUrl : '/';

  const [password, setPassword] = useState('');
  const [phone, setPhone] = useState('');
  const [formValidated, setFormValidated] = useState(false);
  const [phoneValid, setPhoneValid] = useState(true);

  const { state, dispatch: ctxDispatch } = useContext(Store);
  const { userInfo } = state;
  const submitHandler = async (e) => {
    e.preventDefault();

    const form = e.currentTarget;
    if (form.checkValidity() === false) {
      setFormValidated(true);

      if (phone.length !== 12) {
        setPhoneValid(false);
      }
      return;
    }

    if (phone.length !== 12) {
      setPhoneValid(false);
      return;
    }

    try {
      const { data } = await Axios.post('/api/users/signin', {
        phone: '+' + phone,
        password,
        code,
      });
      loginHandler(data, ctxDispatch, localStorage);
      navigate(redirect ? redirect : '/qrmenu');
    } catch (err) {
      toast.error(getError(err));
    }
  };

  useEffect(() => {
    if (userInfo) {
      navigate(redirect);
    }
  }, [navigate, redirect, userInfo]);

  return (
    <Container className="small-container">
      <Helmet>
        <title>Giriş</title>
      </Helmet>
      <h1 className="my-3">Giriş</h1>
      <Form onSubmit={submitHandler} noValidate validated={formValidated}>
        <Form.Group className="mb-3">
          <Form.Label>Telefon</Form.Label>
          <PhoneInput
            country={'tr'}
            onlyCountries={['tr']}
            countryCodeEditable={false}
            value={phone}
            onChange={(p) => {
              setPhone(p);
              setPhoneValid(true);
            }}
            inputStyle={{ width: '100%' }}
            inputProps={{
              name: 'Telefon',
            }}
            isValid={(value, country) => {
              if (!phoneValid) {
                return 'Hatalı telefon numarası';
              }
            }}
          />
        </Form.Group>
        <Form.Group className="mb-3">
          <Form.Label>Şifre</Form.Label>
          <Form.Control
            type="password"
            required
            onChange={(e) => setPassword(e.target.value)}
          />
          <Form.Control.Feedback type="invalid">
            Lütfen şifrenizi giriniz.
          </Form.Control.Feedback>
        </Form.Group>
        <div className="mb-3">
          <Button type="submit">Giriş Yap</Button>
        </div>
        <div className="mb-3">
          Hesabınız yok mu?{' '}
          <Link
            to={`/customer_signup?code=${code}&redirect=${encodeURIComponent(
              redirect
            )}`}
          >
            Hesap oluştur
          </Link>
        </div>
      </Form>
    </Container>
  );
}
